import { useTranslation } from 'react-i18next';
import {
  BlueSubtleSection,
  CardGrid,
  Overline,
  SectionBody,
  SectionHeader,
  SectionHeading,
  SectionInner,
} from '../HostfullyAccountingMarketing.styles';
import { BENEFIT_CARDS } from '../HostfullyAccounting.constants';
import MarketingContentCard from './MarketingContentCard';

const BenefitsSection = () => {
  const { t } = useTranslation();

  return (
    <BlueSubtleSection data-testid="marketing-benefits">
      <SectionInner>
        <SectionHeader>
          <Overline>
            {t('pageHostfullyAccounting.marketing.benefits.overline')}
          </Overline>
          <SectionHeading>
            {t('pageHostfullyAccounting.marketing.benefits.title')}
          </SectionHeading>
          <SectionBody>
            {t('pageHostfullyAccounting.marketing.benefits.description')}
          </SectionBody>
        </SectionHeader>
        <CardGrid $columns={3}>
          {BENEFIT_CARDS.map((card) => (
            <MarketingContentCard key={card.testId} card={card} />
          ))}
        </CardGrid>
      </SectionInner>
    </BlueSubtleSection>
  );
};

export default BenefitsSection;
